import React from "react";
import {
  Route,
  Switch,
  useHistory,
  useLocation
} from 'react-router-dom';
import { i18nextKeys } from "Lang/i18nextKeys";
import i18nextTranslate from "Lang/i18nextTranslate";
import { ROUTES } from "Router/Routes";
import OrderHistory from 'Features/Account/OrderHistory';
import RedeemHistory from 'Features/Account/RedeemHistory';

const TransactionTabs = [
  {
    labelKey: i18nextKeys.orderHistoryHeader,
    path: ROUTES.custom.transactions.orders,
    dataQa: "tab-orders"
  },
  {
    labelKey: i18nextKeys.redeemHistoryHeader,
    path: ROUTES.custom.transactions.redemptions,
    dataQa: "tab-redemptions"
  },
  {
    labelKey: i18nextKeys.customTransactionsTabsTax,
    path: ROUTES.custom.transactions.tax,
    dataQa: "tab-tax"
  }
];

const Transactions = () => {
  const history = useHistory();
  const location = useLocation();
  return (
    <div className="h-full">
      <h1
        class="flex justify-center xxl:mt-40 pb-44 uppercase"
        style={{
          letterSpacing: "10px",
          marginBottom: 0,
          fontSize: "45px",
          lineHeight: "44px",
          fontWeight: 400,
          fontFamily: "Arsenal, sans-serif"
        }}
        data-qa="heading"
      >
        {i18nextTranslate(i18nextKeys.customTransactionsHeading)}
      </h1>
      <div
        class="flex justify-center mt-40 mb-20"
        style={{
          borderBottom: "2px solid #4c4e4e"
        }}
        data-qa="tabs"
      >
        {TransactionTabs.map(tab => (
          <div
            class="w-1/4 py-9 cursor-pointer rounded-t text-center"
            style={{
              fontFamily: "Arsenal, sans-serif",
              fontSize: "18px",
              lineHeight: "20px",
              ...location.pathname === tab.path ? {
                fontWeight: 800,
                color: "white",
                backgroundColor: "#9c9c9c"
              } : {
                fontWeight: 600,
                color: "#7e7e7e",

              }
            }}
            onClick={() => history.push(tab.path)}
            data-qa={tab.dataQa}
          >
            {i18nextTranslate(tab.labelKey)}
          </div>
        ))}
      </div>
      <Switch>
        <Route
          path={[ROUTES.custom.transactions.base, ROUTES.custom.transactions.orders]}
          render={() => <OrderHistory onlyTable />}
          exact
        />
        <Route
          path={ROUTES.custom.transactions.redemptions}
          render={() => <RedeemHistory onlyTable />}
          exact
        />
        <Route
          path={ROUTES.custom.transactions.tax}
          render={() => null}
          exact
        />
      </Switch>
    </div>
  );
};

export default Transactions;
